import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';

const enablingOptions = [
    { value: "Enable", label: "Enable" },
    { value: "Disable", label: "Disable" }
]

const AddSerialMaster = (props) => {

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Serial Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Plant</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Storage Location</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Material #</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label> Short Description</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label> Legacy #</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Asset # </label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label> Serial #</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label> Serial Number Profile</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>SerUsage</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label> EqReq</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>SerLevel</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>QoH</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label className="pb-2 pt-2">Manufacturer / Supplier</label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label className="pb-2 pt-2">Procedure</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={materialGroupClassificationDropdownData}
                                            placeholder="Select"
                                            // value={materialGroupClassificationDropdownData.find(option => option.value === materialGroup.ClassificationID) || null}
                                            // onChange={(selected) => handleSelectChange(selected, "ClassificationID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label className="pb-2 pt-2">Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // options={materialGroupClassificationDropdownData}
                                            placeholder="Select"
                                            // value={materialGroupClassificationDropdownData.find(option => option.value === materialGroup.ClassificationID) || null}
                                            // onChange={(selected) => handleSelectChange(selected, "ClassificationID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddSerialMaster;
